export enum FulfillmentSubTypeType {
  SelfPickup = "SelfPickup",
  Dispatch = "Dispatch",
  ThirdParty = "ThirdParty"
}
